<template>
    <div v-if="questions" class="questions">

        <div>
            <v-layout row wrap class="padding-bottom-l">
                <v-flex sm3 class="progress-circle-status">
                    <div class="cont-svg">
                        <v-progress-circular
                            :value="questionsCountAnswered*100 / questionsCountTotal"
                            class="color-primary"
                            :rotate="-90"
                            :width="1">
                            <radial-progress-svg
                                v-if="questionsCountAnswered === questionsCountTotal"
                                class="margin-top-xxs">
                            </radial-progress-svg>
                        </v-progress-circular>
                    </div>
                </v-flex>

                <v-flex sm9>
                    <span v-if="mustShowCodes && symptomCode" class="font-size-small font-weight-light">
                        [{{ symptomCode }}]&nbsp;
                    </span>
                    <span :class="titleClasses">
                        {{title}}
                    </span>
                    <div>
                        <span class="answered-questions color-element-outline font-size-small font-weight-light">
                            {{questionsCountAnswered}} {{text('api.pro.questionPanel.of')}} {{questionsCountTotal}} {{text('api.pro.questionPanel.answeredQuestions')}}
                        </span>
                    </div>
                </v-flex>
            </v-layout>
        </div>

        <symptom-question-item
            v-for="question in questions"
            :key="question.code"
            :questionData="question"
            :mustShowFullQuestion="mustShowFullQuestion"
            @onProvideQuestionAnswer="handleProvideAnswer">
        </symptom-question-item>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import { mapGetters } from 'vuex';
    import SymptomQuestionItem from "./SymptomQuestionItemPf";
    import RadialProgressSvg from "../svg/productList/radialProgress";

    export default {
        name: 'QuestionListBlockPf',
        components: {
            SymptomQuestionItem,
            RadialProgressSvg
        },

        props: {
            questions: {},
            title: {
                type: String,
                default: ""
            },
            titleClasses: {
                type: String,
                default: "title-assessment-sections"
            },
            symptomCode: {},
            questionsCountAnswered: {
                type: Number,
                default: 0
            },
            questionsCountTotal: {
                type: Number,
                default: 0
            }
        },
        data(){
            return{
                fill : { gradient: ["red"] }
            }
        },
        computed: mapGetters({
            mustShowFullQuestion: 'ProductListStore/getMustShowFullQuestion',
            mustShowCodes: 'UserStore/getDebugMustShowCodes'
        }),

        methods: {
            handleProvideAnswer(data) {
                this.$emit('onProvideAnswer', data);
            }
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss">
    .cont-svg{
        content: '%';
    }

    .progress-circle-status {
        max-width: 45px !important;
    }
</style>




// WEBPACK FOOTER //
// src/common/components/shared/QuestionListBlockPf.vue